import HttpProvider from "./httpProvider";
import {API} from "../constants/api";

class CollectionColumnViewService{

    constructor() {
        this.http = HttpProvider;
    }

    async getByContext(context) {
        return await this.http.get(API.COLLECTION_COLUMN_VIEWS.BY_CONTEXT({ context }), false);
    }

    async updateView(context, name, enabled) {
        return await this.http.get(API.COLLECTION_COLUMN_VIEWS.UPDATE({ context, name, enabled }), false);
    }
}

export default new CollectionColumnViewService()